import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    paginationWrapper: {
        display: "flex",
        marginTop: theme.spacing(5),
        alignItems: "center",
        alignSelf: "flex-end",
        gap: 8,
    },
    paginationText: {
        color: theme.palette.info.main,
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "Source Sans 3",
    },
    paginationButton: {
        color: `${theme.palette.info.main} !important`,
        "&.Mui-disabled": {
            color: `rgba(36, 123, 160, 0.25) !important`,
        },
    },
}));
